import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { formatCents, offerStatusLabel, type OfferSummary, type Paginated } from '@kontor/shared';
import { api, queryString } from '../../api';
import { useSession } from '../../session';
import { offerTone } from './OffersPage';
import './offers.css';

/** Angebote zu einer Anfrage oder einem Kontakt, für deren Detailseiten (KON-103) */
export function RelatedOffers({ inquiryId, contactId }: { inquiryId?: string; contactId?: string }) {
  const { can } = useSession();
  const list = useQuery({
    queryKey: ['offers', { inquiryId, contactId }],
    queryFn: async () => (await api<Paginated<OfferSummary>>('GET', `/offers${queryString({ inquiryId, contactId, perPage: 50 })}`)).data,
  });
  const create = contactId ? `/angebote/neu?kontakt=${contactId}` : `/angebote/neu?anfrage=${inquiryId}`;

  return (
    <section className="card" aria-label="Angebote">
      <div className="section-head">
        <h2>Angebote</h2>
        {can('offers.write') && <Link className="btn btn--secondary btn--sm" to={create}>Neues Angebot</Link>}
      </div>
      {list.isLoading && <p className="muted">Wird geladen …</p>}
      {list.isError && <p className="muted">Die Angebote konnten nicht geladen werden.</p>}
      {list.data?.length === 0 && <p className="muted">Noch kein Angebot.</p>}
      {list.data && list.data.length > 0 && (
        <ul className="related-offers">
          {list.data.map((o) => (
            <li key={o.id}>
              <Link to={`/angebote/${o.id}`} className="strong-link">{o.number ?? 'Entwurf'}</Link>
              <span className={offerTone(o.status, o.sentVia)}>{offerStatusLabel(o.status, o.sentVia)}</span>
              <span className="muted small related-offers__subject">{o.subject}</span>
              <span className="num">{formatCents(o.grossCents)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
